import React from 'react';
import classNames from 'classnames';

import Location from '../lib/wrapped_location';
import { useApplePay } from './apple_pay_hook';

import { useUser } from '@reverbdotcom/commons/src/user_hooks';
import { MParticleEventName } from '@reverbdotcom/commons/src/elog/mparticle_types';
import { trackEvent } from '@reverbdotcom/commons/src/elog/mparticle_tracker';

interface Props {
  listingCurrencyCode: string;
  paymentMethodsConfig: string;
  payButtonType?: 'checkout' | 'plain';
  buttonLocation?: 'hoisted' | 'default';
}

LoggedInApplePayButton.defaultProps = {
  payButtonType: 'plain',
};

export default function LoggedInApplePayButton(props: Props) {
  const user = useUser();

  const { openPaymentSheet, paymentResult } = useApplePay({
    paymentMethodsConfig: props.paymentMethodsConfig,
    listingCurrencyCode: props.listingCurrencyCode,
  });

  const classes = classNames(
    'apple-pay-button',
    { 'apple-pay-button--checkout': props.payButtonType === 'checkout' },
  );

  if (paymentResult.paymentResultUrl) {
    Location.assign(paymentResult.paymentResultUrl);
  }

  const openPaymentSheetWithTracking = buildTrackAndOpenPaymentSheet({ openPaymentSheet, buttonLocation: props.buttonLocation });

  return (
    <div
      role="button"
      tabIndex={0}
      onClick={openPaymentSheetWithTracking}
      onKeyPress={withKeyPressHandling(openPaymentSheetWithTracking)}
      className={classes}
      lang={user.locale}
    >
    </div>
  );
}

function buildTrackAndOpenPaymentSheet({ openPaymentSheet, buttonLocation }) {
  return function trackAndOpenPaymentSheet(event) {
    trackEvent({
      eventName: MParticleEventName.ClickedApplePayButton,
      displayStyle: buttonLocation === 'hoisted' ? 'hoisted' : 'default',
    });

    openPaymentSheet(event);
  };
}

function withKeyPressHandling(handler) {
  return function callHandlerOnKeyPress(event) {
    if (['Enter', ' '].includes(event.key)) {
      handler(event);
    }
  };
}
